import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../sections/cookie-banner';
import '../sections/collection-list';
import '../sections/notification-bar';
import '../sections/site-header';
import '../sections/featured-blog-posts';
import '../sections/beauty-slider';
import '../sections/real-results';
import '../sections/behind-the-scenes';
import '../sections/newsletter-sign-up';

import '../components/search-hero';
import '../components/type';
import '../components/quantity';

import '../snippets/emoji';

import '../helpers/video';
import '../helpers/password-visibility';

import {focusHash} from '@shopify/theme-a11y';
import {load} from '@shopify/theme-sections';

import CartFunctions from '../helpers/cart-functions';
import Accordion from '../components/accordion';
import AjaxCart from '../components/ajax-cart';
import CartTable from '../components/cart-table';
import EventBus from '../helpers/event-bus';
import MobileFooterNav from '../components/mobile-footer-nav';
import Navigation from '../sections/navigation';
import QuickAdd from '../sections/quick-add';
import SearchCollection from '../sections/search-collection';

window.Karmoon = window.Karmoon || {};
window.Karmoon.EventBus = EventBus();

document.addEventListener('DOMContentLoaded', () => {
  CartFunctions().init();
  AjaxCart().init();
  CartTable().init();
  QuickAdd().init();
  Navigation().init();
  MobileFooterNav().init();
  SearchCollection().init();

  if (document.querySelector('.accordion') !== null) {
    Accordion('.accordion').init();
    Accordion('.accordion').hideAllItems();
  }

  load('*');

  if (Shopify.theme.role === 'unpublished') {
    window.console.log(Shopify.theme);
  }

  // Common a11y fixes
  focusHash();
});
